<template>
<div class="chapter">
<div class="inner_page">
<h2 id="heading_id_2">PART ONE</h2>
<p class="first"> </p>
<p class="center" xmlns:xml="http://www.w3.org/XML/1998/namespace"><img alt="" src="Images/8429_PART.jpg"/></p>
<p class="first"> </p>
<p class="h2">BIBLICAL PATTERNS</p>
<p class="h3">Story-Shaped Liturgy</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PARTONE.vue?342ea1cc